import IdentityTile from '@Guidelines/Component/IdentityTile';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const headerStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.125rem;
	padding: 1.5rem;
	border-radius: ${theme.radii.xxlarge};
	background-color: ${theme.colors.accentSurface};
`;

const identityRowStyle = css`
	display: flex;
	gap: 1rem;
	align-items: center;
	flex-wrap: wrap;
`;

const identityTextStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	flex: 1;
	min-width: 0;
`;

const titleRowStyle = css`
	display: flex;
	align-items: center;
	gap: 0.625rem;
`;

const titleStyle = css`
	${theme.typography.pageTitle}
	margin: 0;
	color: ${theme.colors.ink};

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		font-size: 2rem;
	}
`;

const metaRowStyle = css`
	display: flex;
	gap: 1.125rem;
	flex-wrap: wrap;
	margin: 0;
	list-style: none;
	padding: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly initials: string;
	readonly seed: number;
	readonly title: React.ReactNode;
	/** Tags drawn beside the title. */
	readonly tags?: React.ReactNode;
	/** The `<li>` items of the metadata line. */
	readonly metadata: React.ReactNode;
	/** Actions drawn inside the banner, under the identity. */
	readonly children?: React.ReactNode;
};

/** The identity banner of a dossier screen: tile, title, tags, metadata line and actions. */
const SubjectIdentityBanner: React.FC<Props> = ({ initials, seed, title, tags, metadata, children }) => {
	return (
		<header css={headerStyle}>
			<div css={identityRowStyle}>
				<IdentityTile label={initials} seed={seed} size="large" />
				<div css={identityTextStyle}>
					<div css={titleRowStyle}>
						<h1 css={titleStyle}>{title}</h1>
						{tags}
					</div>
					<ul css={metaRowStyle}>{metadata}</ul>
				</div>
			</div>
			{children}
		</header>
	);
};

export default SubjectIdentityBanner;
